import {Modal, ButtonToolbar, Button} from 'rsuite';
import RemindIcon from '@rsuite/icons/legacy/Remind';
import {useState} from "react";
import {toast} from "react-toastify";
import AuthService from "../../../../services/auth.service";
import CampaignService from "../../../../services/campaign.service";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const APP_URL = process.env.APP_URL;
const MealTrial = (props) => {
    const {data, changeDay} = props;
    const [open, setOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    return (<>
            <div className="meal-trial">
                <Modal backdrop="static" role="alertdialog" open={open} onClose={handleClose} size="xs">
                    <Modal.Header closeButton={true}>

                    </Modal.Header>
                    <Modal.Body>
                        <RemindIcon style={{color: '#ffb300', fontSize: 24}}/>
                        {data.body ? <div className="body">{data.body}</div> : ''}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button appearance={isLoading ? 'default' : 'primary'}
                                loading={isLoading}
                                onClick={save}
                                block>
                            <b style={{color: '#fff'}}>{data.button ? data.button : ''}</b>
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );

    function handleClose() {
        setOpen(false);
        changeDay(0);
    }

    function save() {
        navigate('/subscription-packages');
        return false;
        if (isLoading) {
            return false;
        }

        const config = {
            headers: {Authorization: `Bearer ${AuthService.getAccessToken()}`}
        };


        let body = {
            trial_payment: true,
            intend_url: window.location.protocol + "//" + window.location.host + '/subscriptions',
            failed_intend_url: window.location.protocol + "//" + window.location.host + '/dashboard',
        };

        const campaignParameters = CampaignService.get();

        body = {...body, ...campaignParameters}

        setIsLoading(true);

        axios.post(`${APP_URL}/api/gateway-transactions`, body, config)
            .then(function (response) {
                if (response.data.message) {
                    toast.loading(response.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }

                if (response.data.status && response.data.action) {
                    switch (response.data.action) {
                        case 'intent':
                            setTimeout(() => {
                                window.location.replace(response.data.data);
                            }, 2000);
                            break;
                    }
                } else {
                    setIsLoading(false);
                }
            })
            .catch(function (error) {
                setIsLoading(false);

                if (!error.response) {
                    // handleNotfound();
                    toast.error('خطایی رخ داده است!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        const {errors} = error.response.data;

                        for (const errorsKey in errors) {
                            const error = errors[errorsKey][0];
                            toast.error(error, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        break;

                    case 401:
                        navigate('/auth')
                        break;
                    default:
                        toast.error('خطایی رخ داده است!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        break;
                }
            });
    }
}

export default MealTrial;